import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'ten-follow-icons',
  template: `<div class="icon-wrap" [innerHTML]="sanitizedIcon"></div>`,
  styleUrls: ['./follow-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FollowIconsComponent implements OnChanges {
  @Input() public isActive: boolean;
  @Input() public type: string;
  public sanitizedIcon: SafeHtml;

  constructor(private domSanitizer: DomSanitizer) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isActive) {
      this.sanitizedIcon = this.createIcon();
    }
  }

  public createIcon(): SafeHtml {
    let icon: string;
    // I'm putting the svgs here and not in the template just so the formatting is not screwed up

    if (!this.isActive && this.type === 'favorite') {
      icon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" class="favorite-add">
        <circle cx="14" cy="14" r="14" fill="#FFF"/>
        <path d="M20.926 8.71c-3.536-1.92-6.144.566-6.925 1.462-.78-.896-3.385-3.382-6.928-1.462-1.44.782-2.19 2.248-2.058 4.02.225 3.018 3.055 7.05 8.878 9.251a.33.33 0 00.216 0c5.82-2.201 8.653-6.23 8.876-9.248.134-1.775-.618-3.24-2.06-4.023z"/>
      </svg>`;
    }

    if (this.isActive && this.type === 'favorite') {
      icon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" class="favorite-remove">
        <circle cx="14" cy="14" r="14" fill="#FFF"/>
        <path d="M20.926 8.71c-3.536-1.92-6.144.566-6.925 1.462-.78-.896-3.385-3.382-6.928-1.462-1.44.782-2.19 2.248-2.058 4.02.225 3.018 3.055 7.05 8.878 9.251a.33.33 0 00.216 0c5.82-2.201 8.653-6.23 8.876-9.248.134-1.775-.618-3.24-2.06-4.023z"/>
      </svg>`;
    }

    if (!this.isActive && this.type === 'follow') {
      icon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 23 14" class="follow-add">
        <path  d="M16 .7c-3.6-2-6.2.6-7 1.5-.8-1-3.4-3.4-7-1.5a4 4 0 00-2 4c.2 3 3 7 8.9 9.3a.3.3 0 00.2 0c5.8-2.2 8.7-6.2 8.9-9.3a4 4 0 00-2-4z"/>
        <g transform="translate(12 2)">
          <circle stroke="#FFF" cx="5" cy="5" r="5"/>
          <path fill="#FFF" d="M8 5.4H5.3V8h-.8V5.4H2v-.8h2.5V2h.8v2.5H8z"/>
        </g>
      </svg>`;
    }

    if (this.isActive && this.type === 'follow') {
      icon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 23 14" class="follow-remove">
        <path d="M16 .7c-3.6-2-6.2.6-7 1.5-.8-1-3.4-3.4-7-1.5a4 4 0 00-2 4c.2 3 3 7 8.9 9.3a.3.3 0 00.2 0c5.8-2.2 8.7-6.2 8.9-9.3a4 4 0 00-2-4z" />
        <g transform="translate(12 2)">
          <circle stroke="#FFF" cx="5" cy="5" r="5"/>
          <path fill="#FFF" d="M3.8 6.7L2 5l-.6.6 2.4 2.3 5-5-.6-.6z"/>
        </g>
      </svg>`;
    }

    return this.domSanitizer.bypassSecurityTrustHtml(icon);
  }
}
